import {buildServerCall} from '../../../services/wcfService';
import {getConnection} from '../../../_shared/GWTBridge/invoke/genPage';
import {js2xml} from 'xml-js';

export type HomepageItemData = {
    HyperLinkedText?: string;
    countIssues: string;
    disabled: '0' | '1';
    ename: string;
    etype: string;
    exec: string;
    help?: string;
    maydesign: string;
    multicomp: string;
    mymenu: string;
    selected?: string;
    title: string;
    type?: string;
    url?: string;
    zoomtitle?: string;
    id?: string;
};

export const requestHomepageData = async () => {
    const methodName = 'GeneralHomePage';
    const params = {};
    return await buildServerCall(methodName, params, methodName, false, getConnection, false);
};

export const setHomepageData = async (homepageData: Array<{exec: string; title: string}>) => {
    const methodName = 'GeneralHomePageSet';

    const dataset = {
        NewDataSet: {
            Menu: homepageData.map(item => ({exec: item.exec, title: item.title}))
        }
    };

    const xml = window['common'].compressString(
        '<?xml version="1.0" encoding="UTF-8"?>\n' +
            js2xml(dataset, {
                compact: true,
                spaces: 2,
                fullTagEmptyElement: true
            })
    );

    const parameters = {
        xml: [xml]
    };

    const data = await buildServerCall(
        methodName,
        parameters,
        methodName,
        false,
        getConnection,
        false
    );
    return data;
};

export const searchTiles = async (search: string, ignorecase: boolean) => {
    const methodName = 'GeneralSearch';
    const params = {
        str: [search],
        ignorecase: [ignorecase ? 'true' : 'false']
    };

    const data: {General: {Menu: HomepageItemData[]}[]} = await buildServerCall(
        methodName,
        params,
        methodName,
        false,
        getConnection,
        false
    );
    const results = data?.General?.[0]?.Menu || [];

    // filter out only top level items
    return results.filter(item => !(item.title.includes('->') || item.title.includes('<-')));
};

export const getPortlets = async () => {
    const methodName = 'GetPortlets';
    const params = {};

    const data: {General: {Menu: HomepageItemData[]}[]} = await buildServerCall(
        methodName,
        params,
        methodName,
        false,
        getConnection,
        false
    );

    return data?.General?.[0]?.Menu || [];
};

export const removeGroupItem = async (exec: string, title: string) => {
    const methodName = 'GeneralHomePageAddRemove';

    const params = {
        exec: [exec],
        title: [title],
        add: ['0']
    };

    const data: {General: {Menu: HomepageItemData[]}[]} = await buildServerCall(
        methodName,
        params,
        methodName,
        false,
        getConnection,
        false
    );

    return data;
};
